import constants from 'config/constants'

interface StripeAccountBilling {
  publishable_key?: string
  stripe_account?: string
}

export function isUsBilling(billing: StripeAccountBilling | null | undefined): boolean {
  return billing?.stripe_account === 'us'
}

export function getPublishableKey(billing?: StripeAccountBilling | null): string {
  return billing?.publishable_key ?? constants.stripeApiKey
}

interface BillingAddress {
  country?: string | null
  state?: string | null
  postal_code?: string | null
}

export function getMissingUsAddressErrors(address?: BillingAddress | null): string[] {
  const errors: string[] = []
  if (!address?.country) {
    errors.push('Country is required')
  }
  if (address?.country === 'US') {
    if (!address.state) {
      errors.push('State is required')
    }
    if (!address.postal_code) {
      errors.push('Postal code is required')
    }
  }
  return errors
}



// WEBPACK FOOTER //
// ./src/libs/billing/stripe-account/index.ts